<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>Drafts</h1>
        <p class="subtitle">Live customer carts. Read only.</p>
      </div>
      <button
        class="btn-refresh"
        type="button"
        (click)="reload()"
        [disabled]="loading()"
      >
        {{ loading() ? "Refreshing…" : "Refresh" }}
      </button>
    </header>

    @if (loading() && drafts().length === 0) {
      <div class="empty-state">Loading drafts…</div>
    } @else if (drafts().length === 0) {
      <div class="empty-state">No customer drafts right now.</div>
    } @else {
      <div class="drafts-table">
        <div class="drafts-head">
          <span>Type</span>
          <span>Owner</span>
          <span>Blinds</span>
          <span>Cart total</span>
          <span>Updated</span>
          <span></span>
        </div>
        @for (d of drafts(); track d.ownerId) {
          <a class="drafts-row" [routerLink]="['/drafts', d.ownerId]">
            <span class="badge" [class.guest]="d.type === 'guest'">
              {{ d.type === "guest" ? "Guest" : "Signed in" }}
            </span>
            <span class="owner" [title]="d.ownerId">{{ shortOwner(d.ownerId) }}</span>
            <span>{{ d.blindCount }}</span>
            <span class="total">{{ money(d.total) }}</span>
            <span class="muted">{{ dateLabel(d.updatedAt) }}</span>
            <span class="row-actions">
              @if (d.claritySessionId) {
                <button
                  type="button"
                  class="rec-btn"
                  title="Watch Clarity recording"
                  aria-label="Watch Clarity recording"
                  (click)="openRecording($event, d)"
                >
                  ▶
                </button>
              }
              <span class="chev">›</span>
            </span>
          </a>
        }
      </div>
    }
  </div>
</section>
